import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { FactDetails } from '@/api/types/backend-dto-types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

/**
 * Fetches full fact details for the fact panel.
 * Returns complete information including locations, documents, and comments.
 */
export function useGetFactDetails(
  matterId: string | null | undefined,
  subsetId: string | undefined,
  factId?: string | null,
) {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<FactDetails, Error>(
    [QueryEntity.Fact, factId],
    async () => {
      return await fetch(
        `${APIBaseChronos}/api/matters/${matterId}/subsets/${subsetId}/facts/${factId}`,
        fetchConfigGET,
      ).then((res) => {
        if (!res.ok) {
          throw new Error('Failed to fetch fact');
        }
        return res.json();
      });
    },
    { refetchOnWindowFocus: false, enabled: !!matterId && !!subsetId && !!factId, keepPreviousData: true },
  );
}
